const api = {
  login: 'login',
  logout: 'logout',
  courses: 'courses',
  submitVideo: 'courses/submitVideo',
  getSectionQuiz: 'courses/getSectionAssessment',
  getFinalQuiz: 'courses/getFinalAssessment',
  submitQuiz: 'courses/submitAssessment',
  enrollInCourse: 'courses/enroll',
};

export default api;
